import {
  useStyle
} from "@/classify";
import {
  Radio as InformedRadio
} from "informed";
import {
  useContext
} from "react";
import MyContext from "./MyContext";
import defaultClasses from "./radio.module.css";


const RadioOption = (props) => {
  const {
    ariaLabel, classes: propClasses, id, label, value, ...rest 
  } = props
  const classes = useStyle(defaultClasses, propClasses)


  const context = useContext(MyContext);


  const {
    currentValue 
  } = context || {}

  return (
    <label
      className={classes.root}
      htmlFor={id}
      aria-label={ariaLabel || ""}
    >
      <InformedRadio
        {...rest}
        className={classes.input}
        id={id}
        value={value}
      />

      <span className={`${classes.label} ${currentValue === value ? classes.labelActive : ""}`}>
        {label || (value != null ? value : "")}
      </span>
    </label>
  )
}

export default RadioOption
